import React, { useState } from "react";
import {
  HomePageContainer,
  Header,
  IntroSectionFS,
  TeamSectionFS,
  TeamStructure,
  TeamMember,
  WelcomeSectionFS,
  PopupOverlay,
  PopupContent,
  SwiperGlobalStyle,
  SnapContainer,
  FooterSection,
  HeroButtons,
  CTAButton,
  HeroKpis,
  KpiCard,
} from "./styles";
import { HomeSnapGlobal } from "./HomeSnapGlobal";
import oceane from "../../assets/oceane.jpg";
import christine from "../../assets/christine.png";
import cindy from "../../assets/cindy.jpeg";
import catherine from "../../assets/catherine.jpg";
import helena from "../../assets/helena.jpg";

import logo from "../../assets/logo.png";

import entrance from "../../assets/entrance.png";
import espacevie from "../../assets/espace-vie.png";
import espacevie2 from "../../assets/espace-vie-2.png";
import espacevie3 from "../../assets/espace-vie-4.png";
import dortoir_grand from "../../assets/dortoir_grand.png";
import dortoir_petit from "../../assets/dortoir_petit.png";
import cuisine from "../../assets/cuisine.png";
import change from "../../assets/change.png";
import jardin from "../../assets/exterieur.png";

import { Swiper, SwiperSlide } from "swiper/react";

import Footer from "../../components/Footer";

import "swiper/css";
import "swiper/css/navigation";
// import required modules
import { Keyboard, Scrollbar, Navigation, Pagination } from "swiper/modules";

const teamMembers = [
  {
    name: "Océane",
    role: "Directrice & Référente Technique",
    additionalRole: "Éducatrice de jeunes enfants",
    image: oceane,
    description:
      "Je m’appelle Océane, directrice de la micro-crèche et éducatrice de jeunes enfants diplômée. En tant que première interlocutrice, je serai celle avec qui vous échangerez lors de vos premiers contacts avec la crèche. Je prends le temps de vous accueillir, de répondre à vos questions et de vous présenter la structure.",
  },
  {
    name: "Christine",
    role: "Co-directrice",
    additionalRole: "Auxiliaire puéricultrice",
    image: christine,
    description:
      "Christine, co-directrice de la micro-crèche et auxiliaire de puériculture de formation. Elle a à cœur d’accompagner chaque enfant avec douceur, bienveillance et respect de son rythme. Elle est également disponible pour répondre à vos interrogations concernant votre enfant, afin de vous offrir un accompagnement en toute confiance, dans une relation de proximité et d’échange.",
  },
  {
    name: "Cindy",
    role: "Auxiliaire puéricultrice",
    image: cindy,
    description:
      "Cindy accompagnera vos enfants chaque jour au sein de la micro-crèche. Son rôle est de veiller à leur bien-être et à leur confort à travers les soins du quotidien : accompagnement aux repas, changes, suivi de la santé et moments de réconfort.",
  },
  {
    name: "Helena",
    role: "Animatrice Petite Enfance",
    image: helena,
    description:
      "Son rôle est de veiller à leur bien-être tout en leur proposant des activités d’éveil adaptées à leur âge, afin de stimuler leur curiosité, favoriser leurs apprentissages et encourager leur développement global.",
  },
  {
    name: "Catherine",
    role: "Référente santé & d’accueil inclusif",
    image: catherine,
    description:
      "Catherine assure le rôle de référente santé et d’accueil inclusif au sein de la crèche. Elle veille au bien-être et à l’inclusion de chaque enfant, en collaboration avec l’équipe pédagogique et les familles.",
  },
  {
    name: "Natacha",
    role: "Professionnelle animant des analyses de pratiques professionnelles (APP)",
    image: logo,
    description:
      "Natacha, psychologue, professionnelle spécialisée dans l’animation d’Analyses de Pratiques Professionnelles. Son rôle est d’accompagner l’équipe dans sa réflexion sur les situations vécues au quotidien, afin de favoriser la prise de recul, l’enrichissement mutuel et l’amélioration continue des pratiques.",
  },
];

const slides = [
  {
    img: entrance,
    title: "Espace d'accueil",
    desc: "Un espace d’accueil avec des casiers individuels et un plan de change afin que vous puissiez préparer votre enfant à l’arrivée dans l’espace de vie.",
  },
  {
    img: cuisine,
    title: "Cuisine",
    desc: "Une cuisine avec un espace biberonnerie.",
  },
  {
    img: change,
    title: "Change",
    desc: "Une salle de change avec des toilettes adaptées pour l’apprentissage de la propreté et un plan de change favorisant l’autonomie avec un escalier.",
  },
  {
    img: espacevie,
    primary: false,
    title: "Espace de vie",
    desc: "Un espace de vie avec un espace dédié à l’éveil des non marcheurs, des espaces liées aux activités d’imitation : cuisine, poupées, garage, un espace dédié à la motricité.",
  },
  {
    img: espacevie2,
    primary: true,
    title: "Espace de vie",
    desc: "Un espace de vie avec un espace dédié à l’éveil des non marcheurs, des espaces liées aux activités d’imitation : cuisine, poupées, garage, un espace dédié à la motricité.",
  },
  {
    img: espacevie3,
    primary: false,
    title: "Espace de vie",
    desc: "Un espace de vie avec un espace dédié à l’éveil des non marcheurs, des espaces liées aux activités d’imitation : cuisine, poupées, garage, un espace dédié à la motricité.",
  },

  {
    img: dortoir_grand,
    title: "Dortoirs grand",
    desc: "Dortoir avec 6 lits dits « barquettes ».",
  },
  {
    img: dortoir_petit,
    title: "Dortoirs petit",
    desc: "Dortois avec 6 lits à barreaux.",
  },
  {
    img: jardin,
    title: "Jardin aménagé",
    desc: "Un jardin aménagé pour les enfants",
  },
];

const to = "melimelo59630@gmail.com";
const subject = "Demande de visite — Site Méli Mel’O";
const body = `Bonjour,

Je souhaiterais planifier une visite de la micro-crèche Méli Mel’O.

Informations utiles :
– Nom/Prénom :
– Âge de l’enfant :
– Créneaux souhaités :
– Téléphone :

Merci !`;

const mailtoHref =
  `mailto:${to}` +
  `?subject=${encodeURIComponent(subject)}` +
  `&body=${encodeURIComponent(body)}`;

const gmailHref =
  `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(to)}` +
  `&su=${encodeURIComponent(subject)}` +
  `&body=${encodeURIComponent(body)}`;

function handleVisitClick() {
  window.location.href = mailtoHref;

  setTimeout(() => {
    if (document.visibilityState === "visible") {
      window.open(gmailHref, "_blank", "noopener");
    }
  }, 400);
}

const HomePage: React.FC = () => {
  const [selectedMember, setSelectedMember] = useState<
    null | (typeof teamMembers)[0]
  >(null);

  const openPopup = (member: (typeof teamMembers)[0]) =>
    setSelectedMember(member);
  const closePopup = () => setSelectedMember(null);

  return (
    <HomePageContainer>
      <HomeSnapGlobal />
      <SnapContainer>
        <IntroSectionFS>
          <Header>Bienvenue chez Méli Mel’O</Header>

          <div className="intro-logo">
            <img src={logo} alt="Méli Mel’O Logo" />
          </div>
          <div className="intro-text">
            <p>
              <b>Bienvenue à tous !</b> <br /> Nous sommes Christine et Océane,
              mère et fille, toutes deux passionnées et expérimentées dans le
              domaine de la petite enfance. Animées par l’envie de mettre nos
              compétences en commun, nous avons décidé de créer ensemble une
              micro-crèche privée.
            </p>
            <p>
              Notre structure accueillera jusqu’à 12 enfants, du lundi au
              vendredi, de 7h30 à 18h30, dans un environnement bienveillant,
              chaleureux et inclusif.
            </p>
            <p>
              Nous mettons un point d’honneur à offrir un cadre sécurisant et
              épanouissant, où chaque enfant pourra grandir à son rythme et
              s’éveiller au monde qui l’entoure. Nous restons à votre
              disposition pour répondre à vos questions, et à l’écoute de vos
              besoins et attentes.
            </p>
            <HeroButtons>
              <CTAButton className="primary" href="/pre-inscription">
                Pré-inscription
              </CTAButton>
              <CTAButton
                as="button"
                className="ghost"
                onClick={handleVisitClick}
              >
                Planifier une visite
              </CTAButton>
            </HeroButtons>
          </div>
          <HeroKpis>
            <KpiCard>
              <div className="icon">👶</div>
              <div>
                <strong>12 places</strong>
                <small>groupe multi-âge</small>
              </div>
            </KpiCard>
            <KpiCard>
              <div className="icon">⏰</div>
              <div>
                <strong>7h30–18h30</strong>
                <small>lun → ven</small>
              </div>
            </KpiCard>
            <KpiCard>
              <div className="icon">📍</div>
              <div>
                <strong>Looberghe</strong>
                <small>village</small>
              </div>
            </KpiCard>
            <KpiCard>
              <div className="icon">🌱</div>
              <div>
                <strong>Bienveillance</strong>
                <small>rythme & inclusion</small>
              </div>
            </KpiCard>
          </HeroKpis>
        </IntroSectionFS>
        <TeamSectionFS>
          <h2>L’équipe</h2>
          <p>
            L’équipe est composée de 4 professionnelles au quotidien et 2
            professionnelles qui accompagneront l’équipe plusieurs heures dans
            l’année :
          </p>
          <TeamStructure>
            {/* Première ligne : Océane et Christine dans un grid à 4 colonnes */}
            <div className="team-row">
              {teamMembers.slice(0, 2).map((member, index) => (
                <TeamMember
                  key={index}
                  onClick={() => openPopup(member)}
                  style={{ gridColumn: index === 0 ? "2 / 3" : "3 / 4" }} // Positionner Océane et Christine
                >
                  <img src={member.image} alt={member.name} />
                  <p>{member.name}</p>
                  <span>{member.role}</span>
                  <br></br>
                  {member.additionalRole && (
                    <span>{member.additionalRole}</span>
                  )}
                </TeamMember>
              ))}
            </div>

            {/* Deuxième ligne : les autres membres en disposition flex */}
            <div className="team-row">
              {teamMembers.slice(2).map((member, index) => (
                <TeamMember key={index + 2} onClick={() => openPopup(member)}>
                  <img src={member.image} alt={member.name} />
                  <p>{member.name}</p>
                  <span>{member.role}</span>
                </TeamMember>
              ))}
            </div>
          </TeamStructure>
        </TeamSectionFS>
        <WelcomeSectionFS>
          <h2>Présentation des locaux</h2>
          <SwiperGlobalStyle />
          <Swiper
            slidesPerView={1}
            centeredSlides={false}
            grabCursor={true}
            keyboard={{
              enabled: true,
            }}
            breakpoints={{
              769: {
                slidesPerView: 3,
                slidesPerGroup: 3,
              },
            }}
            scrollbar={true}
            navigation={true}
            pagination={{
              clickable: true,
            }}
            modules={[Keyboard, Scrollbar, Navigation, Pagination]}
            className="mySwiper"
          >
            {slides.map((s, i) => {
              const isEspaceVie = s.title === "Espace de vie";
              const cardClass = [
                "slide-card",
                isEspaceVie ? "espaceVie" : "",
                isEspaceVie && s.primary ? "primary" : "",
              ]
                .join(" ")
                .trim();

              return (
                <SwiperSlide key={`${s.img}-${i}`}>
                  <figure className={cardClass}>
                    <img src={s.img} alt={s.title || "photo"} loading="lazy" />
                    {/* on met le caption dans le DOM pour les 3, le CSS décidera de l’afficher */}
                    {(s.title || s.desc) && (
                      <figcaption>
                        {s.title && <h4>{s.title}</h4>}
                        {s.desc && <p>{s.desc}</p>}
                      </figcaption>
                    )}
                  </figure>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </WelcomeSectionFS>
        <FooterSection>
          <Footer />
        </FooterSection>
      </SnapContainer>
      {selectedMember && (
        <PopupOverlay onClick={closePopup}>
          <PopupContent onClick={(e) => e.stopPropagation()}>
            <button onClick={closePopup}>&times;</button>
            <img src={selectedMember.image} alt={selectedMember.name} />
            <h3>{selectedMember.name}</h3>
            <h4>{selectedMember.role}</h4>
            <p>{selectedMember.description}</p>
          </PopupContent>
        </PopupOverlay>
      )}
    </HomePageContainer>
  );
};

export default HomePage;
